import {useViewedFilesCount} from '../../stores/selectors'

import styles from './ViewedFileProgress.module.css'
import {clsx} from 'clsx'

type ProgressIconProps = {
  progress: number
}

const ProgressIcon = ({progress}: ProgressIconProps) => {
  return (
    <svg data-circumference="38" height="16" role="presentation" style={{transform: 'rotate(-90deg)'}} width="16">
      <circle
        cx="50%"
        cy="50%"
        fill="transparent"
        r="6"
        stroke="var(--borderColor-default, var(--color-border-default))"
        strokeWidth="2"
      />
      <circle
        cx="50%"
        cy="50%"
        fill="transparent"
        r="6"
        stroke="var(--fgColor-done, var(--color-done-fg))"
        strokeDasharray={38}
        strokeDashoffset={38 - progress * 38}
        strokeLinecap="round"
        strokeWidth="2"
        style={{transition: 'stroke-dashoffset 0.35s'}}
      />
    </svg>
  )
}

export interface ViewedFileProgressProps {
  totalFilesCount: number
}

export function ViewedFileProgress({totalFilesCount}: ViewedFileProgressProps) {
  const viewedFilesCount = useViewedFilesCount()

  if (totalFilesCount === 0) return null

  return (
    <div className="d-flex flex-row flex-items-center">
      <ProgressIcon progress={(viewedFilesCount ?? 0) / totalFilesCount || 0} />
      <span className={clsx('ml-1', styles.ProgressContainer)}>
        <span className={styles.FilesCountText}>{viewedFilesCount}</span> /{' '}
        <span className={styles.FilesCountText}>{totalFilesCount}</span>{' '}
        <span className={styles.ViewedText}>viewed</span>
      </span>
    </div>
  )
}
